/**
 * A no-op helper function that converts an `EventHandler` type,
 * into a type that's compatible with TypeScript's native DOM declarations.
 *
 * @see EventHandler
 */
export function inferNativeHandler(handler) {
    return handler;
}
/**
 * A no-op helper function that converts a `TypedEvent` type,
 * into a type that's compatible with TypeScript's native DOM declarations.
 *
 * @see EventHandler
 */
export function inferNativeEvent(event) {
    return event;
}
/**
 * A no-op helper function that converts a native event type,
 * into a `TypedEvent` that's compatible with Knyt's event handlers.
 *
 * @see EventHandler
 */
export function inferTypedEvent(event) {
    return event;
}
